import { type FC, useState } from "react";
import { CandyCornLoader } from "./CandyCornLoader";
import { FlappingBatLoader } from "./FlappingBatLoader";
import { PumpkinFillLoader } from "./PumpkinFillLoader";

const LOADERS: readonly { Loader: FC<{ dataTestId?: string }>; testId: string }[] = [
	{ Loader: FlappingBatLoader, testId: "halloween-loader-bat" },
	{ Loader: CandyCornLoader, testId: "halloween-loader-candy-corn" },
	{ Loader: PumpkinFillLoader, testId: "halloween-loader-pumpkin" },
];

// Remembered across mounts in this tab, so the next loading screen always shows a different one.
let lastShownIndex: number | null = null;

const pickNextIndex = (): number => {
	const candidates = LOADERS.map((_, index) => index).filter((index) => index !== lastShownIndex);
	const next = candidates[Math.floor(Math.random() * candidates.length)];
	lastShownIndex = next;
	return next;
};

/** One of the Halloween loading animations, a different one from the last loading screen each time. */
export const HalloweenLoader: FC = () => {
	const [index] = useState(pickNextIndex);
	const { Loader, testId } = LOADERS[index];
	return <Loader dataTestId={testId} />;
};
